import { render, staticRenderFns } from "./HistorySection.vue?vue&type=template&id=336482ab&"
import script from "./HistorySection.vue?vue&type=script&lang=js&"
export * from "./HistorySection.vue?vue&type=script&lang=js&"
import style0 from "./HistorySection.vue?vue&type=style&index=0&id=336482ab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports